export default class Collapsible {
    constructor(targetDiv) {
        if (!targetDiv) throw new Error("targetDiv is mandatory")
        this.targetDiv = targetDiv
    }


    // private methods

    #collapse() {
        this.targetDiv.style.height = `${this.targetDiv.scrollHeight}px`
        this.targetDiv.classList.add("collapsing")
        setTimeout(()=>{
            this.targetDiv.style.height = null
            this.targetDiv.classList.remove("collapse")
            this.targetDiv.classList.remove("show")
            this.getBtn().classList.add("collapsed")
            this.getBtn().setAttribute('aria-expanded', 'false');
        }, 0)
    }
    
    #expand() {
        this.targetDiv.classList.remove("collapse")
        this.targetDiv.classList.add("collapsing")
        this.getBtn().classList.remove("collapsed")
        this.getBtn().setAttribute('aria-expanded', 'true');
        this.targetDiv.style.height = `${this.targetDiv.scrollHeight}px`
    }

    #setListeners() {
        this.getBtn().addEventListener('click', ()=>this.toggle())

        this.targetDiv.addEventListener("transitionend", ()=>{
            console.log(`transitionend`)
            if (!this.isExpanded()) {
                this.targetDiv.classList.remove("collapsing")
                this.targetDiv.classList.add("collapse")
            } else {
                this.targetDiv.classList.remove("collapsing")
                this.targetDiv.classList.add("collapse")
                this.targetDiv.classList.add("show")
                this.targetDiv.style.height = null
            }
        })
    }

    #setCollapsed() {
        this.getBtn().classList.add("collapsed")
        this.targetDiv.classList.remove("show")
        this.getBtn().setAttribute('aria-expanded', 'false');
    }
    #setExpanded() {
        this.getBtn().classList.remove("collapsed")
        this.targetDiv.classList.add("show")
        this.getBtn().setAttribute('aria-expanded', 'true');
    }


    // public methods

    getBtn() {
        const id = this.targetDiv.getAttribute('id')
        return document.querySelector(`[data-target="#${id}"]`)
    }

    isExpanded() {
        return !this.getBtn().classList.contains("collapsed")
    }

    expand() {
        if (!this.isExpanded()) {
            this.#expand()
        }
    }

    collapse() {
        if (this.isExpanded()) {
            this.#collapse()
        }
    }

    toggle() {
        if (this.isExpanded()) {
            this.#collapse()
        } else {
            this.#expand()
        }
    }



    init() {
        if (this.targetDiv.getAttribute("data-collapsible-applied")) {
            return
        }
        // process data-mobile- and data-desktop- attributes to set the divs as collapsed or expanded depending on resolutions
        if (window.screenSizeManager.screenType !== "mobile") {
            if (this.targetDiv.hasAttribute('data-desktop-expanded')) {
                this.#setExpanded()
            } else if (this.targetDiv.hasAttribute('data-desktop-collapsed')) {
                this.#setCollapsed()
            }
        } else {
            if (this.targetDiv.hasAttribute('data-mobile-expanded')) {
                this.#setExpanded()
            } else if (this.targetDiv.hasAttribute('data-mobile-collapsed')) {
                this.#setCollapsed()
            }
        }
        this.#setListeners()
        this.targetDiv.setAttribute("data-collapsible-applied", true)
    }
}